enum Role {
  BASIC = "Basic",
  MANAGER = "Manager",
  SUBSCRIPTION_MANAGER = "SubscriptionManager",
}

export default Role;
